











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {Administrador} from '@/model/resource/Administrador'
import {AdministradorCollection} from '@/model/collection/AdministradorCollection'
import {ListAdministradorSchema} from '@/schema/resource/Administrador/ListAdministradorSchema'
import {CsvAdministradorSchema} from '@/schema/resource/Administrador/CsvAdministradorSchema'

@Component
export default class ListAdministradorView extends Mixins(MixinQueryRouter) {
  schema = new ListAdministradorSchema()
  collection = new AdministradorCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: Administrador) {
    Helper.pushByName('editAdministrador', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new AdministradorCollection().clearFilters().addFilter(params)

    await csv.listCsvAdministrador()
    new CsvAdministradorSchema().downloadCsv(csv.all())
  }
}
